<template>
	<router-view />
</template>

<script>
export default {
	name: 'App',
	// mounted() {
	// 	window.console.log = function () {}
	// },
}
</script>

<style lang="scss"></style>

